<template>
    <organization-and-user/>
</template>

<script>
    import OrganizationAndUser from "_private/components/super/systemSetting/organizationManage/OrganizationAndUser";

    export default {
        components: {
            OrganizationAndUser
        }
    };
</script>
